export default __webpack_public_path__ + "static/media/easel-graph.69afe7db.svg";